"use strict";

/*
    Rolagem sinconizada
*/
$(".one_scroll").scroll(function () {
    $(".two_scroll").scrollLeft($(".one_scroll").scrollLeft());
});
$(".two_scroll").scroll(function () {
    $(".one_scroll").scrollLeft($(".two_scroll").scrollLeft());
});

/*
    Esconde as colunas de qtd ao carregar a página
*/
$('.visao_qtd').hide();

/*
    Formas de visualização
*/
$('input[name="visualizacao"]').on('ifClicked', function (event) {
    if (this.value == 'ambos') {
        $('.visao_valor').show();
        $('.visao_qtd').show();

        $('.th_1_2').attr('colspan', 2);
    } else if (this.value == 'qtd') {
        $('.visao_qtd').show();
        $('.visao_valor').hide();

        $('.th_1_2').attr('colspan', 1);
    } else {
        $('.visao_valor').show();
        $('.visao_qtd').hide();

        $('.th_1_2').attr('colspan', 1);
    }
});

/*
    Filtros de tipos de insumo
*/
$('#insumos_de_material').on('ifClicked', function (event) {
    if ($('#insumos_de_material').val() > 0) {
        $('#insumos_de_material').val(0);
    } else {
        $('#insumos_de_material').val(1);
    }
    filter();
});

$('#insumos_de_servico').on('ifClicked', function (event) {
    if ($('#insumos_de_servico').val() > 0) {
        $('#insumos_de_servico').val(0);
    } else {
        $('#insumos_de_servico').val(1);
    }
    filter();
});

/*
    Modais
*/
$("#modal-obs").on('shown.bs.modal', function () {
    $(this).find('#text_area_obs').focus();
});

$("#modal-justificativa").on('shown.bs.modal', function () {
    $(this).find('#text_area_justificativa').focus();
});

/*
    Processa os filtros da gerencial
*/
function filter() {
    var change = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    startLoading();

    queryString = '';
    obra_id = $('#obra_id').val();
    data = $('#data').val();
    grupo_id = $('#grupo_id').val();
    contrato = $('#contrato').val();
    insumos_de_material = $('#insumos_de_material').val();
    insumos_de_servico = $('#insumos_de_servico').val();
    subgrupo = $('#subgrupo').val();
    servico = $('#servico').val();

    if (obra_id > 0) {
        queryString = '?obra_id=' + obra_id;
    }

    if (data) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'data=' + data;
    }

    if (obra_id > 0 && grupo_id > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'grupo_id=' + grupo_id;
    }

    if (obra_id > 0 && grupo_id > 0 && subgrupo > 0 && change != 'grupos') {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'subgrupo=' + subgrupo;
    }

    if (obra_id > 0 && grupo_id > 0 && subgrupo > 0 && servico > 0 && change != 'grupos' && change != 'subgrupos') {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'servico=' + servico;
    }

    if (contrato) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'contrato=' + contrato;
    }

    if (insumos_de_material > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'insumos_de_material=' + insumos_de_material;
    }

    if (insumos_de_servico > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'insumos_de_servico=' + insumos_de_servico;
    }

    history.pushState("", document.title, location.pathname + queryString);

    location.reload();
}

/*
    Modal de visualização da observação do grupo
*/
function visualizarObsGrupo(id, acao) {
    obs = $('#obs_grupo_' + id).val();

    if (acao) {
        $('#text_area_obs').val(obs);
        $('#modal-obs').modal('show');
        $('#salvar_obs').attr('onclick', 'visualizarObsGrupo(' + id + ', 0);salvarObsGrupo(' + id + ')');
    } else {
        $('#obs_grupo_' + id).val($('#text_area_obs').val());
        $('#modal-obs').modal('hide');
    }
}

/*
    Modal de visualização da observação da apropriação
*/
function visualizarObs(id, acao) {
    obs = $('#obs_' + id).val();

    if (acao) {
        $('#text_area_obs').val(obs);
        $('#modal-obs').modal('show');
        $('#salvar_obs').attr('onclick', 'visualizarObs(' + id + ', 0);salvarObsJustificativa(' + id + ', "obs")');
    } else {
        $('#obs_' + id).val($('#text_area_obs').val());
        $('#modal-obs').modal('hide');
    }
}

/*
    Modal de visualização da justificativa da apropriação
*/
function visualizarJustificativa(id, acao) {
    justificativa = $('#justificativa_' + id).val();

    if (acao) {
        $('#text_area_justificativa').val(justificativa);
        $('#modal-justificativa').modal('show');
        $('#salvar_justificativa').attr('onclick', 'visualizarJustificativa(' + id + ', 0);salvarObsJustificativa(' + id + ', "justificativa")');
    } else {
        $('#justificativa_' + id).val($('#text_area_justificativa').val());
        $('#modal-justificativa').modal('hide');
    }
}

/*
    Abre e fecha o grupo trazendo as apropriações
*/
function openCloseApropriacoes(acao, buscar, gerencial_item_id, subgrupo2_id) {
    if (acao) {
        startLoading();
        if (buscar) {
            getApropriacoes(gerencial_item_id);
        } else {
            stopLoading();
        }
        $('.tr_apropriacoes_' + gerencial_item_id + subgrupo2_id).css('display', '');
        $('.openClose' + gerencial_item_id + subgrupo2_id).attr('onclick', 'openCloseApropriacoes(0, 0, ' + gerencial_item_id + ', ' + subgrupo2_id + ')');
    } else {
        startLoading();

        $('.tr_apropriacoes_' + gerencial_item_id + subgrupo2_id).css('display', 'none');
        $('.openClose' + gerencial_item_id + subgrupo2_id).attr('onclick', 'openCloseApropriacoes(1, 0, ' + gerencial_item_id + ', ' + subgrupo2_id + ')');

        stopLoading();
    }
}

/*
    Calcula e salva o tipo de projeção da apropriação
*/
function calcularTipoProjecao(gerencial_item_insumo_id, tipo_projecao) {

    if (tipo_projecao == 'C') {
        if ($('#justificativa_' + gerencial_item_insumo_id).val() == '') {
            $('#tipo_projecao_' + gerencial_item_insumo_id).val('').select2();
            swal({
                title: 'Preencha a justificativa para fazer a projeção',
                text: '',
                type: 'info',
                allowOutsideClick: true,
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
            });

            return false;
        }
    }

    startLoading();
    $.ajax({
        method: "GET",
        url: "/gerencial/calcularTipoProjecao",
        data: { gerencial_item_insumo_id: gerencial_item_insumo_id, tipo_projecao: tipo_projecao }
    }).done(function (rows) {
        $('#a_gastar_qtd_obra').text(rows['obra']['a_gastar_qtd']);
        $('#a_gastar_valor_obra').text(rows['obra']['a_gastar_valor']);
        $('#tendencia_qtd_obra').text(rows['obra']['tendencia_atual_qtd']);
        $('#tendencia_valor_obra').text(rows['obra']['tendencia_atual_valor']);
        $('#tend_atual_x_tend_anterior_qtd_obra').text(rows['obra']['tend_atual_x_tend_anterior_qtd']);
        $('#tend_atual_x_tend_anterior_valor_obra').text(rows['obra']['tend_atual_x_tend_anterior_valor']);

        $('#a_gastar_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['a_gastar_qtd']);
        $('#a_gastar_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['a_gastar_valor']);
        $('#tendencia_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['tendencia_atual_qtd']);
        $('#tendencia_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['tendencia_atual_valor']);
        $('#tend_atual_x_tend_anterior_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['tend_atual_x_tend_anterior_qtd']);
        $('#tend_atual_x_tend_anterior_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['tend_atual_x_tend_anterior_valor']);
        $('#desvio_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['desvio_qtd']);
        $('#desvio_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['desvio']);
        $('#tipo_projecao_grupo_' + rows['grupo']['id']).text(rows['grupo']['tipo_projecao']);

        $('#a_gastar_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['a_gastar_qtd']);
        $('#a_gastar_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['a_gastar_valor']);
        $('#tendencia_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tendencia_atual_qtd']);
        $('#tendencia_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tendencia_atual_valor']);
        $('#tend_atual_x_tend_anterior_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tend_atual_x_tend_anterior_qtd']);
        $('#tend_atual_x_tend_anterior_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tend_atual_x_tend_anterior_valor']);
        $('#desvio_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['desvio_qtd']);
        $('#desvio_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['desvio']);

        stopLoading();
    });
}

/*
    Salva a observação do grupo
*/
function salvarObsGrupo(gerencial_item_id) {
    startLoading();
    obs = $('#obs_grupo_' + gerencial_item_id).val();

    $.ajax({
        method: "GET",
        url: "/gerencial/salvarObsGrupo",
        data: { gerencial_item_id: gerencial_item_id, obs: obs }
    }).done(function () {
        if (obs == '') {
            $('#btn_obs_grupo_' + gerencial_item_id).removeClass('btn-warning').addClass('btn-default');
        } else {
            $('#btn_obs_grupo_' + gerencial_item_id).removeClass('btn-default').addClass('btn-warning');
        }
        stopLoading();
    });
}

/*
    Salva a classificacao da apropriação
*/
function salvarClassificacao(gerencial_item_insumo_id, classificacao) {
    startLoading();
    $.ajax({
        method: "GET",
        url: "/gerencial/salvarClassificacao",
        data: { gerencial_item_insumo_id: gerencial_item_insumo_id, classificacao: classificacao }
    }).done(function () {
        stopLoading();
    });
}

/*
    Salva a observação da apropriação
*/
function salvarObsJustificativa(gerencial_item_insumo_id, campo) {
    startLoading();
    if (campo == 'obs') {
        valor = $('#obs_' + gerencial_item_insumo_id).val();
    } else {
        valor = $('#justificativa_' + gerencial_item_insumo_id).val();
    }

    $.ajax({
        method: "GET",
        url: "/gerencial/salvarObsJustificativa",
        data: { gerencial_item_insumo_id: gerencial_item_insumo_id, campo: campo, valor: valor }
    }).done(function () {
        if (campo == 'obs') {
            if (valor == '') {
                $('#btn_obs_' + gerencial_item_insumo_id).removeClass('btn-warning').addClass('btn-default');
            } else {
                $('#btn_obs_' + gerencial_item_insumo_id).removeClass('btn-default').addClass('btn-warning');
            }
        } else {
            if (valor == '') {
                $('#btn_justificativa_' + gerencial_item_insumo_id).removeClass('btn-warning').addClass('btn-default');
            } else {
                $('#btn_justificativa_' + gerencial_item_insumo_id).removeClass('btn-default').addClass('btn-warning');
            }
        }

        stopLoading();
    });
}

/*
    Modal de detalhes de ordem de compra
*/
function detalhesOrdemDeCompra(codigo_insumo, data, obra_id) {
    startLoading();
    $('.tr_oc').remove();

    $.ajax({
        url: '/gerencial/visualizacao/detalhes-de-ordem-de-compra',
        data: {
            codigo_insumo: codigo_insumo,
            data: data,
            obra_id: obra_id
        }
    }).done(function (retorno) {
        $.each(retorno.itens, function (index, item) {

            $('#tbody_oc').append('\
                    <tr class="tr_oc">\
                        <td>' + item.codigo_insumo + '</td>\
                        <td>' + item.insumo_nome + '</td>\
                        <td>' + item.unidade_de_medida + '</td>\
                        <td><a href="/ordens-de-compra/detalhes/' + item.id + '" target="_blank">' + item.id + '</a></td>\
                        <td>' + floatToMoney(item.qtd, "") + '</td>\
                        <td>' + floatToMoney(item.valor_unitario) + '</td>\
                        <td>' + floatToMoney(item.valor_total) + '</td>\
                    </tr>');

            if (index + 1 == retorno.itens.length) {
                stopLoading();
                $('#modal-detalhes-ordem-de-compra').modal('show');
            }
        });
    });
}

/*
    Modal de detalhes de contrato
*/
function detalhesContrato(codigo_insumo, data, obra_id) {
    startLoading();
    $('.tr_contrato').remove();

    $.ajax({
        url: '/gerencial/visualizacao/detalhes-de-contrato',
        data: {
            codigo_insumo: codigo_insumo,
            data: data,
            obra_id: obra_id
        }
    }).done(function (retorno) {
        $.each(retorno.itens, function (index, item) {
            valor_contratado = (item.qtd - moneyToFloat(item.realizado_qtd.replace('.', ','))) * item.valor_unitario + moneyToFloat(item.realizado_valor.replace('.', ','));
            saldo_qtd = item.qtd - item.realizado_qtd;
            saldo_valor = valor_contratado - item.realizado_valor;

            $('#tbody_contrato').append('\
                    <tr class="tr_contrato">\
                        <td>' + item.codigo_insumo + '</td>\
                        <td>' + item.insumo_nome + '</td>\
                        <td>' + item.unidade_de_medida + '</td>\
                        <td><a href="/contratos/' + item.id + '" target="_blank">' + item.contrato_nome + '</a></td>\
                        <td>' + floatToMoney(item.qtd, "") + '</td>\
                        <td>' + floatToMoney(valor_contratado) + '</td>\
                        <td>' + floatToMoney(moneyToFloat(item.realizado_qtd.replace('.', ',')), "") + '</td>\
                        <td>' + floatToMoney(moneyToFloat(item.realizado_valor.replace('.', ','))) + '</td>\
                        <td>' + floatToMoney(saldo_qtd, "") + '</td>\
                        <td>' + floatToMoney(item.valor_unitario) + '</td>\
                        <td>' + floatToMoney(saldo_valor) + '</td>\
                    </tr>');

            if (index + 1 == retorno.itens.length) {
                stopLoading();
                $('#modal-detalhes-contrato').modal('show');
            }
        });
    });
}

/*
    Modal de detalhes de realizado no mês
*/
function detalhesRealizadoMes(codigo_insumo, data, obra_id) {
    startLoading();

    $('.tr_realizado_mes').remove();

    $.ajax({
        url: '/gerencial/visualizacao/detalhes-de-realizado-mes',
        data: {
            codigo_insumo: codigo_insumo,
            data: data,
            obra_id: obra_id
        }
    }).done(function (retorno) {
        $.each(retorno.itens, function (index, item) {
            type = item.type == 'M' ? 'notasfiscais' : 'notasfiscaisservicos';
            $('#tbody_realizado_mes').append('\
                    <tr class="tr_realizado_mes">\
                        <td>' + item.codigo_insumo + '</td>\
                        <td>' + item.insumo_nome + '</td>\
                        <td>' + item.unidade_de_medida + '</td>\
                        <td>' + item.data_competencia + '</td>\
                        <td><a href="/' + type + '/' + item.nf_id + '/edit" target="_blank">' + item.numero_nf + '</a></td>\
                        <td>' + item.fornecedor + '</td>\
                        <td>' + floatToMoney(parseFloat(item.qtd), "") + '</td>\
                        <td>' + floatToMoney(moneyToFloat(item.valor_unitario.replace('.', ','))) + '</td>\
                        <td>' + floatToMoney(typeof item.valor_total == 'string' ? moneyToFloat(item.valor_total.replace('.', ',')) : item.valor_total) + '</td>\
                    </tr>');

            if (index + 1 == retorno.itens.length) {
                stopLoading();
                $('#modal-detalhes-realizado-mes').modal('show');
            }
        });
    });
}

/*
    Modal de detalhes de realizado
*/
function detalhesRealizado(codigo_insumo, data, obra_id) {
    startLoading();

    $('.tr_realizado').remove();

    $.ajax({
        url: '/gerencial/visualizacao/detalhes-de-realizado',
        data: {
            codigo_insumo: codigo_insumo,
            data: data,
            obra_id: obra_id
        }
    }).done(function (retorno) {
        $.each(retorno.itens, function (index, item) {
            $('#tbody_realizado').append('\
                    <tr class="tr_realizado">\
                        <td>' + item.codigo_insumo + '</td>\
                        <td>' + item.insumo_nome + '</td>\
                        <td>' + item.unidade_de_medida + '</td>\
                        <td>' + item.mes + '</td>\
                        <td>' + floatToMoney(moneyToFloat(item.realizado_qtd.replace('.', ',')), "") + '</td>\
                        <td>' + floatToMoney(moneyToFloat(item.realizado_valor.replace('.', ','))) + '</td>\
                        <td onclick=modalRealizados("' + item.insumo_detalhes + '","' + item.mes_detalhes + '","' + item.obra_detalhes + '") style="cursor:pointer"><button class="btn btn-sm btn-primary"><i class="fa fa-plus"></i></button></td>\
                    </tr>');

            if (index + 1 == retorno.itens.length) {
                stopLoading();
                $('#modal-detalhes-realizado').modal('show');
            }
        });
    });
}

/*
    Sincronização dos modais de realizado
*/
function modalRealizados(codigo_insumo, data, obra_id) {
    startLoading();

    $('#modal-detalhes-realizado').modal("toggle");

    $('#modalAcumuladoTotal').val(1);

    setTimeout(function () {
        detalhesRealizadoMes(codigo_insumo, data, obra_id);
    }, 1000);
}

$('#modal-detalhes-realizado-mes').on('hidden.bs.modal', function (e) {

    if ($('#modalAcumuladoTotal').val() == 1) {
        $('#modal-detalhes-realizado').modal("toggle");
        $('#modalAcumuladoTotal').val(0);
    }
});

/*
    Modal de projeções
*/
$(document).on('click', '.js-modal-projecao', function (e) {

    e.preventDefault();

    startLoading();

    $.ajax({
        url: $(this).attr('href')
    }).done(function (retorno) {

        stopLoading();
        $('#modal-body-projecao').html(retorno);
        $('#modal-projecao').modal("toggle");
    });
});